import { useSelector } from 'react-redux'
import {
  selectGlobalFilter,
  selectGlobalFilterForApi,
  selectGlobalFilterSaveKey
} from 'redux/selectors/GlobalFilter'
import { TGlobalFilterApiInput } from 'types/GlobalGlobalFilter'

/**
 * Hook for getting the complete global filter state
 */
export const useGlobalFilter = () => {
  return useSelector(selectGlobalFilter)
}

/**
 * Hook for getting the global filter formatted for API calls (snake_case)
 */
export const useGlobalFilterForApi = (): TGlobalFilterApiInput => {
  return useSelector(selectGlobalFilterForApi)
}

/**
 * Hook for getting the save key for global filter
 * (used for caching widget data)
 * Returns 'all', 'standard', comma-separated list of real estate IDs,
 * or companyGroupId for company group variant
 */
export const useGlobalFilterSaveKey = (): string | null => {
  return useSelector(selectGlobalFilterSaveKey)
}
